/**
 * Strips the site host URL from a string
 * @returns modified relative URL string
 * @category Utils
 */
export const removeUrlHost = (url) => url.replace(/^(?:https?:\/\/)?[^/]+/, '')
